import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import finalBanner from "../../assets/finalbanner.png";

import {
  FaMicrochip,
  FaCogs,
  FaBolt,
  FaShieldAlt
} from "react-icons/fa";
import "./TransformerOilPumps.css"; // reused CSS

// Assets
import mono1 from "../../assets/services-11.jpg";
import mono2 from "../../assets/services-11.jpg";

const MonoblockPumps = () => {
  const models = [
    {
      id: "MB-100",
      name: "100 LPM @ 25 m Head",
      type: "Traction Duty Application",
      img: mono1
    },
    {
      id: "MB-010",
      name: "10 LPM @ 35 m Head",
      type: "High Head Application",
      img: mono2
    }
  ];

  return (
    <div className="cyber-root">
      <div className="blueprint-bg"></div>

      {/* HERO SECTION */}
     <section
  className="hud-hero"
  style={{
    backgroundImage: `
      linear-gradient(
        to bottom,
        rgba(143, 182, 243, 0.65), /* light blue overlay (top) */
        rgba(214, 230, 250, 0.55), /* soft blue overlay (middle) */
        rgba(255, 255, 255, 0.75)  /* white overlay (bottom) */
      ),
      url(${finalBanner})
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="hero-content">
   <motion.h1
  className="hero-main-title"
  initial={{ opacity: 0, x: -60 }}
  animate={{ opacity: 1, x: 0 }}
  transition={{ duration: 0.9, ease: "easeOut" }}
>
     SELF-PRIMING MONOBLOCK PUMPS
</motion.h1>

  </div>
</section>

      <div className="dashboard-container">
        {/* SIDEBAR */}
        <aside className="sidebar-nav">
          <h3>Product Categories</h3>

          <nav className="nav-buttons">
            <Link to="/products/transformer-oil-pumps">
              Glandless Transformer Oil Pumps
            </Link>
            <Link className="active" to="/products/monoblock-pumps">
              Self-Priming Monoblock Pumps
            </Link>
            <Link to="/products/canned-motor-pumps">
              Sealless Canned Motor Pumps
            </Link>
            <Link to="/products/marine-pumps">
              Marine Centrifugal Pumps
            </Link>
            <Link to="/products/process-pumps">
              Centrifugal Process Pump
            </Link>
          </nav>

          <button className="side-btn">Technical Catalog</button>
        </aside>

        {/* MAIN CONTENT */}
        <main className="industrial-panel">
             <div className="panel-top">
                    <FaShieldAlt className="cyan-icon" />
                    <h2>  Self-Priming Monoblock Pumps</h2>
                  </div>
                  <br/>
          {/* DESCRIPTION */}
      <p className="company-description">
  {/* <strong>Self-Priming Monoblock Pumps</strong> */}
 
  Flowtech Self Priming Monoblock pumps are centrifugal type pumps suitable for
  self-priming. The pump set is compact in construction and suitable for
  <strong> traction duty</strong> and
  <strong> outdoor applications</strong>. The unique design of the pump set
  ensures <strong>minimum maintenance</strong> and
  <strong> trouble-free operation</strong>.
  <br /><br />
  These pumps are self-priming in design and suitable for
  <strong> battery-operated power supply</strong> on AC coaches. These are
  capable of sustaining the
  <strong> “g” levels</strong> enumerated in the transport system for
  <strong> 100 LPM @ 25 m</strong> and
  <strong> 10 LPM @ 35 m</strong>.
  <br /><br />
  Facility is available to develop self-priming pumps up to
  <strong> 1700 LPM</strong>.
</p>


          {/* TECH SPECS */}
          <div className="tech-specs">
            <div className="spec-item">
              <FaBolt className="cyan-icon" />
              <div>
                <span>PERFORMANCE RANGE</span>
                <p>10 LPM – 1700 LPM</p>
              </div>
            </div>

            <div className="spec-item">
              <FaMicrochip className="cyan-icon" />
              <div>
                <span>APPLICATION</span>
                <p>Traction Duty & AC Railway Coaches</p>
              </div>
            </div>

            <div className="spec-item">
              <FaCogs className="cyan-icon" />
              <div>
                <span>DESIGN</span>
                <p>Self-Priming Monoblock Pump</p>
              </div>
            </div>
          </div>

          {/* PRODUCT MODELS */}
          <section className="product-showcase">
            <h3 className="section-label">Available Models</h3>
            <br/>
            <div className="product-grid">
              {models.map((m) => (
                <motion.div
                  key={m.id}
                  whileHover={{ y: -8 }}
                  className="pump-card"
                >
                  <div className="img-holder">
                    <span className="pump-id">{m.id}</span>
                    <img src={m.img} alt={m.name} />
                  </div>
                  <div className="pump-details">
                    <h4>{m.name}</h4>
                    <p>{m.type}</p>
                                  <Link to="/products/monoblock-pumps" onClick={() => window.scrollTo(0, 0)}> 
  <button className="view-btn">View Datasheet</button>
</Link>
                  </div>
                </motion.div>
              ))}
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};

export default MonoblockPumps;
